import type { SubmitInputAction } from "../types/actions";
import type { RoundInput, StoneFlickingCoreState } from "../types/game-state";

export function applySubmitInput(
  state: StoneFlickingCoreState,
  action: SubmitInputAction,
): StoneFlickingCoreState {
  const input: RoundInput = {
    participantId: action.participantId,
    entityId: action.entityId,
    impulse: action.impulse,
  };

  const newPendingInputs = new Map(state.pendingInputs);
  newPendingInputs.set(action.participantId, input);

  return {
    ...state,
    pendingInputs: newPendingInputs,
    submittedParticipants: [
      ...state.submittedParticipants,
      action.participantId,
    ],
  };
}
